import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {DatePicked} from "../date-picker-custom/model/date-picked";
import {
    CreateFeedbackGQL,
    CreateFeedbackInput,
    Feedback, FeedbackFile, FeedbackFileInput,
    RemoveFeedbackFileGQL,
    UpdateFeedbackGQL, UpdateFeedbackInput, User,
    UserByNameGQL, UserByNameQuery
} from "../../../generated/graphql";
import moment from "moment";
import {QueryRef} from "apollo-angular";
import {FeedbackService} from "../../service/feedback.service";

declare var $: any;

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    solicitationQuery: QueryRef<UserByNameQuery>;

    userByName: User[] = [];
    dropdownSettingsUnities = {};
    selectedUser: any;
    userId: string = '';

    // Aba ativa. Sempre inicia em 'behavioral' para preservar o fluxo atual.
    feedbackType = 'behavioral';
    // Editando um feedback existente a troca de aba fica travada: o backend
    // removeu `type` de UpdateFeedbackInput, um feedback nao muda de tipo.
    isTypeLocked = false;

    // Anexos enviados ao S3 nesta sessao do modal, ainda nao persistidos.
    uploadedFiles: FeedbackFileInput[] = [];
    uploading = false;

    templateFileUrl = 'assets/files/Acompanhamento_Campo.xlsx';

    @Input()
    user: User;

    @Input()
    feedback: Feedback = new Feedback();

    @Output()
    updateList: EventEmitter<any> = new EventEmitter<any>();

    constructor(public router: Router,
                private userByNameGQL: UserByNameGQL,
                private createFeedbackGQL: CreateFeedbackGQL,
                private updateFeedbackGQL: UpdateFeedbackGQL,
                private removeFeedbackFileGQL: RemoveFeedbackFileGQL,
                private feedbackService: FeedbackService,
                public translate: TranslateService) {
        super(router, translate)
    }

    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        if (!this.isNullOrUndefined(this.user)) {
            this.selectedUser = [{id: this.user.id, name: this.user.name}];
        } else this.selectedUser = null;
        if (this.isNullOrUndefined(this.feedback.date)) {
            this.feedback.date = moment().utc(true).format();
        }
        this.handlerFeedbackType();
    }


    ngOnInit(): void {
        this.dropdownSettingsUnities = {
            singleSelection: false,
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 1,
            enableCheckAll: false,
            allowSearchFilter: true,
            searchPlaceholderText: 'Buscar',
            noDataAvailablePlaceholderText: this.translate.instant('NoContributorsFound'),
            allowRemoteDataSearch: true
        };
        if (this.isNullOrUndefined(this.user)) {
            this.actionUser();
        }
    }

    // Guardado como propriedade para poder remover exatamente este handler no
    // ngOnDestroy, sem derrubar os do proprio Bootstrap.
    private onModalHidden = () => this.resetState();

    ngAfterViewInit(): void {
        // Primeiro bind de 'hidden.bs.modal' do projeto -- ha precedente de
        // 'shown.bs.modal' em CropImageComponent. O evento dispara nos tres
        // caminhos de fechamento, porque todos passam por .modal('hide').
        $('#modalFeedback').on('hidden.bs.modal', this.onModalHidden);
    }

    ngOnDestroy(): void {
        $('#modalFeedback').off('hidden.bs.modal', this.onModalHidden);
        super.destroyModal('modalFeedback');
    }

    // <app-feedback> fica montado permanentemente no template das telas pai:
    // fechar o modal apenas o esconde, o componente NAO e destruido. Sem este
    // reset o estado local sobrevive de uma abertura para a outra -- anexos do
    // colaborador A acabariam gravados para o colaborador B.
    resetState() {
        this.uploadedFiles = [];
        this.uploading = false;
        // Nao zera feedbackType/isTypeLocked na marra: re-deriva do @Input.
        // Reabrir o MESMO feedback nao dispara ngOnChanges (a referencia nao
        // muda), entao forcar 'behavioral' aqui faria um feedback tecnico
        // reabrir na aba errada e destravada.
        this.handlerFeedbackType();
    }

    actionUser() {
        this.solicitationQuery = this.userByNameGQL.watch({data: this.userId});
        this.solicitationQuery.valueChanges.subscribe(({data}) => {
            this.userByName = data.userByName as User[];
        });
    }

    onKey(value: any) {
        this.solicitationQuery.refetch({
            data: value.length < 3 ? '' : value
        });
    }

    selectedDate(event: DatePicked) {
        this.feedback.date = moment(event.end).utc(true).format();
    }

    // Abas ------------------------------------------------------------------

    handlerFeedbackType() {
        if (!this.isNullOrUndefined(this.feedback) && !this.isNullOrUndefined(this.feedback.id)) {
            this.feedbackType = this.feedback.type === 'technical' ? 'technical' : 'behavioral';
            this.isTypeLocked = true;
            return;
        }
        this.feedbackType = 'behavioral';
        this.isTypeLocked = false;
        this.uploadedFiles = [];
    }

    // Trocar de aba MANTEM os uploadedFiles. O arquivo ja subiu para o S3 no
    // momento em que foi selecionado, entao limpar a lista aqui nao desfaria o
    // upload -- so obrigaria o usuario a reenviar caso voltasse para a aba
    // tecnica. Se ele salvar como comportamental, os objetos ficam orfaos no
    // S3, o que e aceitavel; o que nao pode acontecer e criar vinculo no banco,
    // e isso esta garantido pela guarda de tipo em actionCreate/actionUpdate.
    setFeedbackType(type: string) {
        if (this.isTypeLocked) {
            return;
        }
        this.feedbackType = type;
    }

    // Anexos ----------------------------------------------------------------

    getPersistedFiles(): FeedbackFile[] {
        if (this.isNullOrUndefined(this.feedback) || this.isNullOrUndefined(this.feedback.files)) {
            return [];
        }
        return this.feedback.files as FeedbackFile[];
    }

    countFiles(): number {
        return this.uploadedFiles.length + this.getPersistedFiles().length;
    }

    // formatFileSize foi promovido para o BaseComponent: a Home e o historico
    // do colaborador tambem listam anexos.

    // Ordem obrigatoria: upload REST -> fileKey -> mutation. O createFeedback
    // retorna DefaultMessage sem os ids, entao nao ha "salva e anexa depois".
    onSelectFiles(event: any) {
        const files: FileList = event.target.files;
        if (this.isNullOrUndefined(files) || files.length === 0) {
            return;
        }

        this.uploading = true;
        let pending = files.length;

        for (let i = 0; i < files.length; i++) {
            this.feedbackService.uploadFile(files[i]).subscribe({
                next: (data: any) => {
                    this.uploadedFiles.push({
                        name: data.name,
                        fileKey: data.fileKey,
                        size: data.size
                    });
                    pending--;
                    if (pending === 0) {
                        this.uploading = false;
                    }
                },
                error: err => {
                    pending--;
                    if (pending === 0) {
                        this.uploading = false;
                    }
                    super.onError(err);
                }
            });
        }

        // Permite reenviar o mesmo arquivo logo em seguida.
        event.target.value = '';
    }

    // Recem-adicionado: nada foi persistido, basta sair do array local.
    removeUploadedFile(index: number) {
        if (index > -1) {
            this.uploadedFiles.splice(index, 1);
        }
    }

    // Ja persistido: soft delete no backend.
    removePersistedFile(file: FeedbackFile) {
        super.confirmMessage(this.translate.instant('baseComponent.warningAttention'),
            this.translate.instant('confirmedFeedbackFileDeleted'), () => {
                this.removeFeedbackFileGQL.mutate({id: file.id}).subscribe(() => {
                    const list = this.getPersistedFiles();
                    const index = list.findIndex(f => f.id === file.id);
                    if (index > -1) {
                        list.splice(index, 1);
                    }
                    this.updateList.emit();
                    super.showMessage(this.translate.instant('baseComponent.success'),
                        this.translate.instant('feedbackFileDeleted'), 'success');
                }, error => super.onError(error));
            });
    }

    // Salvar ----------------------------------------------------------------

    onSave() {
        if (this.uploading) {
            this.showMessage(this.translate.instant('baseComponent.warning'),
                this.translate.instant('uploadingFiles'), 'warning');
            return;
        }

        const arrValidateFields = [
            {value: this.selectedUser, text: 'Colaborador<br>'},
            {value: this.feedback.description, text: 'Descrição<br>'},
        ];

        const stringError = this.validateField(arrValidateFields);

        if (!super.isNullOrUndefined(stringError)) {
            this.showMessage(this.translate.instant('baseComponent.warning'), `${this.translate.instant('FillFieldsCorrectly')} <br> ${stringError}`);
            return;
        }

        // O backend nao exige anexo no feedback tecnico de proposito; a regra
        // de negocio vive aqui.
        if (this.feedbackType === 'technical' && this.countFiles() === 0) {
            this.showMessage(this.translate.instant('baseComponent.warning'),
                this.translate.instant('feedbackFileRequired'), 'warning');
            return;
        }

        // O feedback comportamental nao aceita anexos. Se o usuario subiu
        // arquivos na aba tecnica e voltou para esta aba, eles seriam
        // descartados em silencio -- o bloco de anexos fica escondido aqui.
        if (this.feedbackType === 'behavioral' && this.uploadedFiles.length > 0) {
            super.confirmMessage(this.translate.instant('baseComponent.warningAttention'),
                this.translate.instant('confirmBehavioralWithFiles'), () => {
                    this.persist();
                });
            return;
        }

        this.persist();
    }

    persist() {
        if (super.isNullOrUndefined(this.feedback.id)) {
            this.actionCreate();
        } else {
            this.actionUpdate();
        }
    }

    actionCreate() {
        const arrUser = this.selectedUser.map(({id}) => ({id}));
        let data: CreateFeedbackInput = {
            date: this.feedback.date,
            description: this.feedback.description,
            type: this.feedbackType,
            user: arrUser
        };
        if (this.feedbackType === 'technical') {
            data.files = this.uploadedFiles.map(f => ({name: f.name, fileKey: f.fileKey, size: f.size}));
        }
        this.createFeedbackGQL.mutate({input: data}).subscribe(() => {
            this.uploadedFiles = [];
            this.closeModal('modalFeedback')
            this.updateList.emit();
            this.showMessage(this.translate.instant('baseComponent.success'), 'Feedback realizado com  sucesso', 'success');
        }, error => super.onError(error));
    }

    actionUpdate() {
        const arrUser = this.selectedUser.map(({id}) => ({id}));
        // `type` nao vai no update: UpdateFeedbackInput nao tem o campo.
        let data: UpdateFeedbackInput = {
            id: this.feedback.id,
            date: this.feedback.date,
            description: this.feedback.description,
            user: arrUser
        };
        // `files` no update e aditivo no backend: manda so o que foi anexado
        // agora. Remocao passa exclusivamente por removeFeedbackFile.
        if (this.feedbackType === 'technical' && this.uploadedFiles.length > 0) {
            data.files = this.uploadedFiles.map(f => ({name: f.name, fileKey: f.fileKey, size: f.size}));
        }
        this.updateFeedbackGQL.mutate({input: data}).subscribe(() => {
            this.uploadedFiles = [];
            this.closeModal('modalFeedback')
            this.updateList.emit();
            this.showMessage(this.translate.instant('baseComponent.success'), 'Feedback atualizado com  sucesso', 'success');
        }, error => super.onError(error));
    }
}
